// extracted by mini-css-extract-plugin
export default {"content":"GLSSFS03Popup_content__vWG4A","locName":"GLSSFS03Popup_locName__6Q8-F","expirationLabel":"GLSSFS03Popup_expirationLabel__eNBJp","markRed":"GLSSFS03Popup_markRed__ZnfuL"};